// import { Component, OnInit, HostListener  } from '@angular/core';
// import { AuthService } from './services/auth/auth.service';
// import { IdleService } from './services/idle.service';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.css']
// })
// export class AppComponent implements OnInit {
//   constructor(private authService: AuthService,private idleService: IdleService) {}
//   @HostListener('document:contextmenu', ['$event'])
//   onRightClick(event: MouseEvent) {
//     event.preventDefault();
//   }

//   @HostListener('document:keydown', ['$event'])
//   onKeyDown(event: KeyboardEvent) {

//     if (event.key === 'F12') {
//       event.preventDefault();
//     }

//     if (
//       event.ctrlKey &&
//       event.shiftKey &&
//       ['I', 'J', 'C'].includes(event.key.toUpperCase())
//     ) {
//       event.preventDefault();
//     }

//     if (event.ctrlKey && event.key.toLowerCase() === 'u') {
//       event.preventDefault();
//     }
//   }
//   ngOnInit() {
//      const token = localStorage.getItem('authToken');
//     if (token) {
//       this.idleService.startWatching();
//     }
//   }
// }


import { Component, OnInit } from '@angular/core';

import { IdleService } from './services/idle.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(
 
    private idleService: IdleService,
  ) {}

  ngOnInit() {
    const token = localStorage.getItem('authToken');
    if (token) {
      this.idleService.startWatching();
    }

    document.oncontextmenu = null;
    document.onkeydown = null;
  }
}


